import {AbstractControl, ValidatorFn} from "@angular/forms";

export function forbiddenValueValidator(forbiddenValue: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value = control.value;
    return value === forbiddenValue ? { forbiddenValue: true } : null;
  };
}
